import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {SpecialCompbaser} from "../../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {IUser} from "../../../interfaces";
import moment from "moment-timezone";
import {Lib} from "../../../../libs/Lib";
import {isHostDevOrLocal, popupWindow} from "../../../common";

type Sched = Array<ISched>;

interface ISched {
    day: string;
    time: string[];
}

@Component({
    selector: 'app-chat-welcome',
    templateUrl: './chat-welcome.component.html',
    styleUrls: ['./chat-welcome.component.scss']
})
export class ChatWelcomeComponent extends SpecialCompbaser implements OnInit {

    m_newUserName = '';
    m_firstMessage = '';
    m_buttonText;
    m_mode: 'EMAIL' | 'USER' | 'GUEST';
    handleCountdown;
    nextAgentD = 0;
    nextAgentH = '00';
    nextAgentM = '00';
    nextAgentS = '00';

    supportTimes: Sched = [
        {
            day: 'Sunday',
            time: []
        },
        {
            day: 'Monday',
            time: ['00:00:01', '23:59:00']
        },

        {
            day: 'Tuesday',
            time: ['00:00:01', '23:59:00']
        },
        {
            day: 'Wednesday',
            time: ['00:00:01', '23:59:00']
        },
        {
            day: 'Thursday',
            time: ['00:00:01', '23:59:00']
        },
        {
            day: 'Friday',
            time: ['00:00:01', '23:59:00']
        },
        {
            day: 'Saturday',
            time: []
        }
    ];

    public stringJSPipeArgs = {toDateFromTimestamp: ['MM-DD-YY hh:mm:ss a', 0]};

    constructor(dialog: MatDialog, private toastr: ToastrService, private translocoService: TranslocoService) {
        super(dialog);
        this.setCountdown();

    }

    @Input()
    set value(i_value) {
        this.m_mode = i_value;
        this.m_buttonText = i_value;
    }

    @Input()
    set setUser(i_user: IUser) {
        if (i_user)
            this.m_newUserName = i_user.username;
    }

    @Output() userSubmitted: EventEmitter<any> = new EventEmitter<any>();


    ngOnInit() {
    }

    onClicked() {
        this.userSubmitted.emit({mode: this.m_mode, user: this.m_newUserName, firstMessage: this.m_firstMessage});
    }

    countdownUpdate() {


        function getRemaining(ts) {
            const now = moment.tz("America/Los_Angeles").format('YYYY-MM-DD HH:mm:ssZ');
            const then = moment(ts);
            const diff = then.diff(now);
            const dur = moment.duration(diff);
            const parts = [];
            for (const part of ['days', 'hours', 'minutes', 'seconds']) {
                const d = dur[part]();
                const pp: any = part;
                dur.subtract(moment.duration(d, pp));
                parts.push(d);
            }
            return parts;
        }

        const whenIsChatOpen = () => {
            const now = moment.tz("America/Los_Angeles");
            const dayToday = moment.tz("America/Los_Angeles").day();
            const onToday = this.supportTimes[dayToday];
            /* support is open today, let's find out if its open currently, and if it is open now, return 'NOW' otherwise return date it will be open next */
            if (onToday.time.length > 0) {
                const startTime = onToday.time[0];
                const endTime = onToday.time[1];
                const startDate = moment.tz("America/Los_Angeles").format(`YYYY-MM-DD`) + ' ' + startTime;
                const startDate2 = moment.tz(startDate, "America/Los_Angeles");
                const endDate = moment.tz("America/Los_Angeles").format(`YYYY-MM-DD`) + ' ' + endTime;
                const endDate2 = moment.tz(endDate, "America/Los_Angeles");
                const isBetween = now.isBetween(startDate2, endDate2);
                if (isBetween) return [0, 0, 0, 0];
            }

            /* support is not open today, so let's find out the next time it is open */
            for (let i = 1; i < 8; i++) {
                const dayName = moment.tz("America/Los_Angeles").day(+i).day();
                const timeRange = this.supportTimes[dayName].time;
                if (timeRange.length > 0) {
                    const dayToday3 = moment.tz("America/Los_Angeles").add(i, 'days');
                    const startTime = timeRange[0];
                    const endTime = timeRange[1];
                    const startDate = dayToday3.tz("America/Los_Angeles").format(`YYYY-MM-DD`) + ' ' + startTime;
                    const future2 = moment.tz(startDate, "America/Los_Angeles");
                    return getRemaining(future2);
                }
            }
        };

        const dateChatBeOpen = whenIsChatOpen();
        this.nextAgentD = dateChatBeOpen[0];
        this.nextAgentH = Lib.PadZeros(dateChatBeOpen[1], 2, false);
        this.nextAgentM = Lib.PadZeros(dateChatBeOpen[2], 2, false);
        this.nextAgentS = Lib.PadZeros(dateChatBeOpen[3], 2, false);
    }

    clearCountdown() {
        if (!this.handleCountdown) return;
        clearInterval(this.handleCountdown);
        this.handleCountdown = null;
    }

    setCountdown() {
        if (this.handleCountdown) return;
        this.handleCountdown = setInterval(() => {
            this.countdownUpdate();
        }, 1000);
    }

    override destroy() {
        super.destroy();
        this.clearCountdown();
    }

}
